import { apiFetch } from './client';

export interface MemoryFact {
  id: string;
  content: string;
  scope: string;
  pinned: boolean;
  updated_at: string;
}

export const memoryApi = {
  listFacts: (opts?: { scope?: string; search?: string; pinnedOnly?: boolean }) => {
    const q = new URLSearchParams();
    if (opts?.scope) q.set('scope', opts.scope);
    if (opts?.search) q.set('search', opts.search);
    if (opts?.pinnedOnly) q.set('pinned', 'true');
    const qs = q.toString();
    return apiFetch<MemoryFact[]>(`/api/memory/facts${qs ? '?' + qs : ''}`);
  },
  addFact: (content: string, scope = 'global') =>
    apiFetch<{ id: string }>('/api/memory/facts', { method: 'POST', body: JSON.stringify({ content, scope }) }),
  updateFact: (id: string, patch: { content?: string; pinned?: boolean; scope?: string }) =>
    apiFetch<{ ok: boolean }>(`/api/memory/facts/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  deleteFact: (id: string) => apiFetch<void>(`/api/memory/facts/${id}`, { method: 'DELETE' }),
  forgetAll: () => apiFetch<{ deleted: number }>('/api/memory/facts', { method: 'DELETE' }),
  getSettings: () => apiFetch<{ enabled: boolean }>('/api/memory/settings'),
  setEnabled: (enabled: boolean) =>
    apiFetch<{ ok: boolean }>('/api/memory/settings', { method: 'PUT', body: JSON.stringify({ enabled }) }),
};
